const copy = () => {
    $("body").on("click", ".copy-button", async function (e) {
        const $element = $(this).closest(".voucher-code").find(".code-value");
        const $copyButtons = $(".copy-button");
        const copyText = e.target.textContent;
        const copiedText = $copyButtons.data("copied");
        if (!navigator.clipboard) {
            return;
        }
        try {
            await navigator.clipboard.writeText($element.text());
            e.target.textContent = copiedText;
            if ($copyButtons.length > 1) {
                $copyButtons
                    .not(e.target)
                    .replaceWith('<span class="copy-button" data-copied="' + copiedText + '">' + copyText + "</span>");
            }
        } catch (error) {
            console.error("Failed to copy!", error);
        }
    });
};

module.exports = {
    copy,
    methods: {},
};
